/**
 * Utility functions for handling workflow attachments
 */

/**
 * Read a file as a data URL (base64)
 * @param {File} file - The file to read
 * @returns {Promise<string>} Promise that resolves to the data URL
 */
export const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/**
 * Get the URL for an attachment from various possible formats
 * @param {Object} attachment - The attachment object
 * @returns {string} The attachment URL or empty string
 */
export const getAttachmentUrl = (attachment) =>
  attachment?.path ||
  attachment?.url ||
  attachment?.data ||
  attachment?.fileData ||
  "";

/**
 * Check if an attachment URL can be opened (is a valid URL or data URL)
 * @param {string} url - The URL to check
 * @returns {boolean} True if the URL can be opened
 */
export const canOpenAttachment = (url) =>
  typeof url === "string" &&
  (url.startsWith("http") || url.startsWith("data:"));

/**
 * Prepare file attachments for upload
 * @param {File[]} files - Array of files to prepare
 * @returns {Promise<Array>} Promise that resolves to an array of prepared attachment objects
 */
export const prepareAttachments = async (files) => {
  if (!files || files.length === 0) return [];

  return Promise.all(
    files.map(async (file) => {
      const data = await readFileAsDataUrl(file);
      return {
        originalName: file.name,
        mimeType: file.type,
        size: file.size,
        data,
      };
    })
  );
};















